import axios from "axios";
import environment from "../environment";
import {callAPI, USER_TYPE} from "./api-service";
import {tokenService} from "./token.service";

export class consultantService {
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  constructor() {}

  async getConsultantData() {
    const result = await callAPI({
      method: "GET",
      userType: USER_TYPE.CONSULTANT,
      endpoint: "consultant/settings/consultantData",
      needsToken: true
    });
    return result.data;
  }

  async createConsultant(data) {
    const result = await callAPI({
      method: "POST",
      userType: USER_TYPE.ADMIN,
      endpoint: "consultant/settings/consultantData",
      needsToken: true,
      data: data
    });
    return {
      success: result.status
    };
  }

  async getAllConsultantData() {
    const result = await callAPI({
      method: "GET",
      userType: USER_TYPE.ADMIN,
      endpoint: "consultant/settings/allConsultantData",
      needsToken: true
    });
    return result.data.returnObj;
  }

  async adminUpdateConsultantData(data) {
    const token = await new tokenService().get(USER_TYPE.ADMIN);
    const result = await callAPI({
      method: "PATCH",
      userType: USER_TYPE.ADMIN,
      endpoint: "consultant/settings/adminConsultantData",
      needsToken: true,
      data: {
        ...data,
        token: token.token
      }
    });
    return {
      success: result.status
    };
  }

  async updateConsultantData(data) {
    const result = await callAPI({
      method: "PATCH",
      userType: USER_TYPE.CONSULTANT,
      endpoint: "consultant/settings/consultantData",
      needsToken: true,
      data: data
    });
    return {
      success: result.status
    };
  }

  async getConsultantCases() {
    const result = await callAPI({
      method: "GET",
      userType: USER_TYPE.CONSULTANT,
      endpoint: "consultant/settings/consultantCases",
      needsToken: true
    });
    return result.data;
  }

  async getConsultantCasesData(reqData) {
    const result = await callAPI({
      method: "GET",
      userType: USER_TYPE.CONSULTANT,
      endpoint: "consultant/settings/consultantForms",
      needsToken: true,
      params: reqData
    });
    return result.data;
  }

  async getEnabledConsultants() {
    const result = await callAPI({
      method: "GET",
      userType: USER_TYPE.ADMIN,
      endpoint: "consultant/settings/consultantCases",
      needsToken: true
    });
    return result.data;
  }

  async assignConsultant(req) {
    const result = await callAPI({
      method: "PATCH",
      userType: USER_TYPE.ADMIN,
      endpoint: "consultant/forms/assignConsultant",
      needsToken: true,
      data: req
    });
    return {
      success: result.status
    };
  }

  async sendToFObyConsultant(formId, email, token) {
    // DEPRECATED
    return {
      success: true
    };
    // eslint-disable-next-line
    try {
      // const result = {
      //   status: 200,
      //   message: "ok"
      // };
      const result = await axios({
        method: "POST",
        url: `${environment.baseUrl}consultant/forms/sendToFObyConsultant`,
        headers: {
          Authorization: "Bearer " + token,
          "app-version": "1.0.1"
        },
        data: {
          formId: formId,
          email: email,
          token: token
        }
      });
      //console.log(result);
      return {
        success: true,
        data: result.data
      };
    } catch (e) {
      return {
        status: false,
        message: e.response.data.message
      };
    }
  }

  async updatePOAbyConsultant(req) {
    const result = await callAPI({
      method: "POST",
      userType: USER_TYPE.CONSULTANT,
      endpoint: "consultant/forms/updatePOAbyConsultant",
      needsToken: true,
      data: req
    });
    return {
      success: result.status
    };
  }

  async getVeriffImagesByConsultant(data) {
    const result = await callAPI({
      method: "GET",
      userType: USER_TYPE.CONSULTANT,
      endpoint: `consultant/forms/veriffImagesByConsultant/${data}`,
      needsToken: true,
      responseType: "blob"
    });
    return {
      success: result.status,
      data: result.data
    };
  }

  async denyFormByConsultant(id, comment, token) {
    const result = await callAPI({
      method: "POST",
      userType: USER_TYPE.CONSULTANT,
      endpoint: "consultant/forms/denyByConsultant",
      needsToken: true,
      data: {
        formId: id,
        comment: comment
      }
    });
    return {
      success: result.status,
      data: result.data
    };
  }

  async assignMultipleToConsultant(req) {
    // DEPRECATED - kind of, since its automated
    const result = await callAPI({
      method: "POST",
      userType: USER_TYPE.ADMIN,
      endpoint: "consultant/forms/assignMultipleToConsultant",
      needsToken: true,
      data: req
    });
    return {
      success: result.status,
      data: result.data
    };
  }

  async getFormDataById(req, admin = false) {
    const result = await callAPI({
      method: "GET",
      userType: USER_TYPE.CONSULTANT,
      endpoint: `consultant/forms/getFormDataByID/${req}`,
      needsToken: true,
      data: req
    });
    return {
      success: result.status,
      data: result.data
    };
  }

  async finishANVcontrol(req, comment) {
    const result = await callAPI({
      method: "POST",
      userType: USER_TYPE.CONSULTANT,
      endpoint: "consultant/forms/finishANVcontrol",
      needsToken: true,
      data: {formId: req, comment: comment}
    });
    return {
      success: result.status,
      data: result.data
    };
  }

  async sendMultipleToFObyConsultant(ids) {
    const result = await callAPI({
      method: "POST",
      userType: USER_TYPE.CONSULTANT,
      endpoint: "consultant/forms/sendMultipleToFinanzOnline",
      needsToken: true,
      data: {formIds: ids}
    });
    return {
      success: result.status,
      data: result.data
    };
  }

  async downloadZIP(formId) {
    const result = await callAPI({
      method: "GET",
      userType: USER_TYPE.CONSULTANT,
      endpoint: `consultant/forms/download/${formId}`,
      needsToken: true,
      responseType: "blob"
    });
    const url = window.URL.createObjectURL(new Blob([result.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `ANV-${formId}.zip`);
    document.body.appendChild(link);
    link.click();
    return {
      success: result.status
    };
  }

  async getInvoices(formId) {
    const result = await callAPI({
      method: "GET",
      userType: USER_TYPE.CONSULTANT,
      endpoint: `consultant/invoices/formExpenses/${formId}`,
      needsToken: true
    });
    return result.data;
  }

  async requestInvoice(req) {
    const result = await callAPI({
      method: "POST",
      userType: USER_TYPE.CONSULTANT,
      endpoint: `consultant/invoices/requestInvoices/${req.formId}`,
      needsToken: true,
      data: req.data
    });
    return result.data;
  }

  async getActionRequiredInvoices(formId) {
    const result = await callAPI({
      method: "GET",
      userType: USER_TYPE.CONSULTANT,
      endpoint: `consultant/invoices/formInvoices/${formId}`,
      needsToken: true
    });
    return result.data;
  }

  async confirmInvoices(data) {
    const result = await callAPI({
      method: "POST",
      userType: USER_TYPE.CONSULTANT,
      endpoint: `consultant/invoices/confirmInvoices/${data.id}`,
      needsToken: true,
      data: {
        consultantCorrectedExpenseAmount: data.consultantCorrectedExpenseAmount
      }
    });
    return {
      success: result.status,
      data: result.data
    };
  }

  async reRequestInvoice(data) {
    const result = await callAPI({
      method: "POST",
      userType: USER_TYPE.CONSULTANT,
      endpoint: `consultant/invoices/reRequestInvoice/${data.invoiceId}`,
      needsToken: true,
      data: {
        comment: data.comment
      }
    });
    return result.data;
  }

  async sendConsultantComment(data) {
    const result = await callAPI({
      method: "POST",
      userType: USER_TYPE.CONSULTANT,
      endpoint: "consultant/invoices/makeComment",
      needsToken: true,
      data: {
        invoiceId: data.invoiceId,
        commentContent: data.commentContent
      }
    });
    return {
      success: result.status,
      data: result.data
    };
  }

  async getMismatches({page = 1, limit = 10, status}) {
    const result = await callAPI({
      method: "GET",
      userType: USER_TYPE.CONSULTANT,
      endpoint: "consultant/forms/mismatches",
      needsToken: true,
      params: {page, limit, status}
    });

    return {
      success: result.status,
      data: result.data
    };
  }

  async changeMismatchStatus(userId, status) {
    const result = await callAPI({
      method: "PUT",
      userType: USER_TYPE.CONSULTANT,
      endpoint: "consultant/forms/changeMismatchStatus",
      needsToken: true,
      data: {user_id: userId, status}
    });

    return {
      success: result.status,
      data: result.data
    };
  }

  async getStatistics() {
    const result = await callAPI({
      method: "GET",
      userType: USER_TYPE.CONSULTANT,
      endpoint: "consultant/forms/statistics",
      needsToken: true
    });

    return {
      success: result.status,
      data: result.data
    };
  }
}
